<div [class.open]="isOpen"
  class="side-sheet fixed top-0 bottom-0 h-screen sm:w-full lg:w-1/2 z-30 overflow-y-auto right-[-100%] bg-[#2B2B33] rounded-lg my-4 py-3 px-5 overflow-scroll">
  <div class="flex flex-col w-full h-full">
    <div class="flex flex-row justify-start items-center  ">
     
        <app-close-icon class=" text-white cursor-default   h-2 w-2" (appClickableDirective)="toggle()" />
     
     
        <span class="text-sm font-medium ml-3 -mb-2">String Info</span>
    
    </div>


    <div class="flex flex-col  mt-4 items-start">
    <span class="text-[#3B82F6] font-bold text-xl  ">{{ plantName }} </span>
     <div> <span class="text-xs font-semibold text-[#9CA3AF]">Connected Device</span></div>
      <div class="flex flex-row items-center space-x-2 mt-1">
      <span  class="text-sm font-medium text-[#9CA3AF]" >{{ statsData?.modelName }} | </span>
      <span class="text-sm font-normal text-[#9CA3AF]" >Last Updated: {{ (statsData?.stats)!.last_updated_timestamp * 1000  | date: "dd/MM/yyyy hh:mm:ss a"
  }}
      </span></div></div>
    
    <div class=" w-full grid overflow-auto max-h-80  mt-4 thin-scrollbar
    ">
      @if (statsData?.inverterType===inverterType.GTI) {
      <div class="rounded-lg ">
        <table class="w-full table-fixed border-collapse z-20">
          <thead class="bg-[#0B57D0] sticky top-0 z-10
          w-full 
      ">
            <tr>
              @for (item of gtiHeaderKeys; track $index) {
              <th class="px-4 py-3 text-center text-white font-medium  text-sm ">
                {{ item }}
              </th>
              }
            </tr>
          </thead>

          <tbody class="z-10">
           @for (item of gtiStringTableDetails?.strings; track $index) {
            <tr class="border-[0.5px] border-[#37415180] border-solid bg-[#33333D]">
              <td class="px-4 py-3 text-center text-sm text-[#D1D5DB]">
                {{ item.stringId }}
              </td>
              <td class="px-4 py-3 text-center text-sm text-[#D1D5DB]">
                {{ item.voltage }}
              </td>
              <td class="px-4 py-3 text-center text-sm text-[#D1D5DB]">
                {{ item.current }}
              </td>
              <td class="px-4 py-3 text-center text-sm text-[#D1D5DB]">
                {{ item.power }}
              </td>
            </tr>
            }
           
          </tbody>
        </table>
      </div>}
      @else{
      <div class="rounded-lg overflow-auto grid">
        <table class="w-full table-fixed border-collapse z-20">
          <thead class="bg-[#0B57D0] sticky top-0 z-10
      ">
      <tr> 
            @for (item of headerKeys; track $index) {
            <th class = "px-4 py-3 text-center text-white font-medium
             text-sm"
            >{{item}}</th>
            }</tr>
          </thead>
          <tbody>
            <tr class="bg-[#33333D]">
            @for(item of stringInfoData?.strings;track $index){
            <td class="px-4 py-3 text-center text-sm text-[#D1D5DB]" >{{item.pvNames}}</td>
            <td class="px-4 py-3 text-center text-sm text-[#D1D5DB]"> {{item.pvVolltage}}</td>
            <td class="px-4 py-3 text-center text-sm text-[#D1D5DB]" >{{item.pvCurrent}}</td>
            <td class="px-4 py-3 text-center text-sm text-[#D1D5DB]"> {{item.pvPower}}</td>   }</tr>
          </tbody>
        </table>
      </div>
      }
    </div>


    <div class="mt-7 ">
      <span class="font-semibold  text-lg text-[#E5E7EB]" >Trends</span>
      <div>
        <div class="flex flex-wrap border-b border-gray-200 dark:border-gray-700">
          <div class="flex flex-row justify-center items-center w-full space-x-6">
            <div
              class="dark:bg-none px-5 h-[2.375rem]  py-2 dark:text-white rounded-full w-[7.45rem]
              border-solid border-[1px] border-[#4B5563]  flex items-center space-x-2 cursor-pointer"
              [ngClass]="{
                voltage: selectedTab === stringInfoType.VOLTAGE
              }" (appClickableDirective)="selectTab(stringInfoType.VOLTAGE)">
              <span class="text-[#F3F4F6]  text-sm font-medium
              "> Voltage (V)</span>
            </div>
            <div
              class="dark:bg-none px-5   py-2 dark:text-white rounded-full w-[7.45rem]
               border-solid border-[1px] border-[#4B5563] flex items-center space-x-2 cursor-pointer h-[2.375rem]"
              [ngClass]="{
                current: selectedTab === stringInfoType.CURRENT
              }" (appClickableDirective)="selectTab(stringInfoType.CURRENT)">
              <span class="text-[#F3F4F6] text-sm font-medium "> Current (A)</span>
            </div>
            <div class="dark:bg-none px-5 h-[2.375rem]  py-2 dark:text-white rounded-full w-[7.45rem]
             border-solid border-[1px] border-[#4B5563]
                flex items-center space-x-2 cursor-pointer"
              [ngClass]="{
                power: selectedTab === stringInfoType.POWER
              }" (appClickableDirective)="selectTab(stringInfoType.POWER)">
              <span class="text-[#F3F4F6] text-sm font-medium"
              > Power (kW)</span>
            </div>
          </div>
        </div>
        <div class="flex mb-11
        ">
          <div class="bg-[#33333D80] rounded-xl p-2 my-4 z-10
          flex-grow text-black">
            @if (
            chartOptions &&
            chartOptions.chart?.type &&
            chartOptions.series &&
            chartOptions.series.length > 0
            ) {
            <apx-chart [series]="chartOptions.series!" [chart]="chartOptions.chart!" [xaxis]="chartOptions.xaxis!"
              [yaxis]="chartOptions.yaxis!" [tooltip]="chartOptions.tooltip!" [dataLabels]="chartOptions.dataLabels!"
              [stroke]="chartOptions.stroke!" [plotOptions]="chartOptions.plotOptions!" [grid]="chartOptions.grid!"
              [legend]="chartOptions.legend!" [colors]="chartOptions.colors!"></apx-chart>
            } @else {
            <div class="flex flex-grow justify-center items-center">
              <span class="text-xs dark:text-white">{{
                "no_record_found" | translate
                }}</span>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Overlay -->
@if(isOpen){
<div class="overlay" (appClickableDirective)="toggle()"></div>
}